<template>
    <div class="nio-dialog" v-if="visible" >
        <div class="nio-dialog-container">
            <div class="nio-dialog__header" v-if="title">
                <slot name="title">{{ title }}</slot>
            </div>
            <div class="nio-dialog__body text-wrap" v-if="content">
                <slot name="content">{{ content }}</slot>
            </div>
            <div class="nio-dialog__footer">
                <div class="footer-btn" v-if="showCancel" :class="cancelClass" @click="handleCancel">
                  {{ cancelText || '取消' }}
                </div>
                <div class="footer-btn primary" v-if="showConfirm" :class="confirmClass" @click="handleConfirm">
                  {{ confirmText || '确定' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'nio-dialog',
    props: {
        visible: Boolean,
        title: String,
        content: String,
        cancelText: String,
        confirmText: String,
        showCancel: {
            type: Boolean,
            default: true
        },
        showConfirm: {
            type: Boolean,
            default: true
        },
        cancelClass: String,
        confirmClass: String
    },
    methods: {
        handleCancel() {
            this.$emit('cancel');
        },
        handleConfirm() {
            this.$emit('confirm');
        }
    }
};
</script>

<style lang="less">
@import '~@/assets/css/mixin.less';
@import '~@/assets/css/variable.less';
.nio-dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    left: 0;
    top: 0;
    z-index: 1000;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3)
}

.nio-dialog-container {
  box-sizing: border-box;
  width: 280 * @layout375;
  padding: 20 * @layout375;
  background-color: white;
  border-radius: 2 * @layout375;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.nio-dialog__header {
    margin-bottom: 15 * @layout375;
    font-size: 18 * @layout375;
    line-height: 25 * @layout375;
    font-weight: 500;
    text-align: center;
    color: #040B29;
}

.nio-dialog__body {
  font-size: 16 * @layout375;
  line-height: 24 * @layout375;
  text-align: center;
  color: #040B29;
}

.nio-dialog__footer {
  width: 100%;
  margin-top: 20 * @layout375;
  display: flex;
}

.footer-btn {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45 * @layout375;
  flex: 1;
  margin-right: 15 * @layout375;
  font-size: 16 * @layout375;
  border: 1 * @layout375 solid #040B29;
  color: #040B29;
  border-radius: 0;
  padding: 0;
}
.footer-btn button {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.footer-btn:active {
  color: #FFF;
  background: #040B29;
}
.footer-btn:last-child {
  margin-right: 0;
}
.footer-btn.primary {
  color: #FFF;
  background: #00BEBE;
  border: none;
}
.footer-btn.radius {
  border-radius: 50 * @layout375;
}
.footer-btn.primary:active {
  background: #009292;
}
</style>



// WEBPACK FOOTER //
// src/testdrive_components/common/nio-dialog.vue